import React from 'react';

/**
 * ErrorBoundary - wraps components to catch render-time errors.
 * Without this, React 16+ silently unmounts the whole tree on error, showing
 * a white screen with no visible indication of what went wrong.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    fontFamily: 'Exo 2, sans-serif',
                    padding: '40px',
                    textAlign: 'center'
                }}>
                    <h2 style={{ fontSize: '24px', fontWeight: '800', marginBottom: '16px' }}>
                        Something went wrong
                    </h2>
                    <p style={{ fontSize: '14px', color: '#888', marginBottom: '24px' }}>
                        {this.state.error && this.state.error.toString()}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 24px',
                            background: '#000',
                            color: '#fff',
                            border: 'none',
                            cursor: 'pointer',
                            fontFamily: 'Exo 2, sans-serif',
                            fontSize: '14px'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
